import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";
import { isVendorApp } from "@/Utils";
import { resolvePageTitle } from "./resolvePageTitle";

const PageTitleManager: React.FC = () => {
	const { pathname } = useLocation();
	const {
		opportunityId,
		opportunityName,
		documentId,
		documentName,
		templateId,
		templateName,
		documentCompanyName,
		clientId,
		clientName,
		productId,
		productName
	} = useSelector(
		(state: GlobalState) => ({
			opportunityId: state.opportunities.currentActiveOpportunity?.id,
			opportunityName: state.opportunities.currentActiveOpportunity?.name,
			documentId: state.documents.currentActiveDocument?.id,
			documentName: state.documents.currentActiveDocument?.name,
			templateId: state.templates.currentActiveTemplate?.id,
			templateName: state.templates.currentActiveTemplate?.name,
			documentCompanyName:
				state.documents.currentActiveDocument?.company?.name,
			clientId: state.clients.currentActiveClient?.id,
			clientName: state.clients.currentActiveClient?.name,
			productId: state.products.currentActiveProduct?.id,
			productName: state.products.currentActiveProduct?.name
		}),
		shallowEqual
	);

	useEffect(() => {
		if (isVendorApp()) {
			return;
		}
		window.document.title = resolvePageTitle({
			pathname,
			opportunity: { id: opportunityId, name: opportunityName },
			document: {
				id: documentId,
				name: documentName,
				companyName: documentCompanyName
			},
			template: { id: templateId, name: templateName },
			client: { id: clientId, name: clientName },
			product: { id: productId, name: productName }
		});
	}, [
		pathname,
		opportunityId,
		opportunityName,
		documentId,
		documentName,
		templateId,
		templateName,
		documentCompanyName,
		clientId,
		clientName,
		productId,
		productName
	]);

	return null;
};

export default PageTitleManager;
